<template>
  <div class="index-container">
    <dataFilter ref="dataFilter" :filter="filter">
      <el-button type="primary" @click="handleQuery()">查询</el-button>
      <el-button type="warning" @click="handleExport()">导出</el-button>
    </dataFilter>
    <div class="tab-content">
      <el-table border size="mini" :data="datas" style="width: 100%">
        <el-table-column label="基本信息" show-overflow-tooltip align="center">
          <el-table-column
            prop="Check.Code"
            fixed="left"
            label="测试编号"
            :width="180"
          >
          </el-table-column>
          <el-table-column label="客户姓名" :min-width="80">
            <template slot-scope="scope">
              <div>
                {{ scope.row.Check.Member.RealName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="Check.Member.Mobile"
            label="手机号"
            :width="120"
          >
          </el-table-column>
          <el-table-column prop="Check.Member.Sex" label="性别" :width="60">
          </el-table-column>
          <el-table-column label="报告日期" :min-width="120">
            <template slot-scope="scope">
              <el-tag type="success">{{
                format.dateFormat(scope.row.Check.ReportDate)
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="肺活量" show-overflow-tooltip align="center">
          <el-table-column
            label="肺活量"
            prop="VitalCapacity"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="肺活量预测"
            prop="VitalCapacityForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="用力肺活量"
            prop="ExertVitalCapacity"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="用力肺活量预测"
            prop="ExertVitalCapacityForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="一秒量"
            prop="OneSecond"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="一秒量预测"
            prop="OneSecondForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="一秒率"
            prop="OneSecondRate"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="一秒率预测"
            prop="OneSecondRateForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="最大通气量"
            prop="MaxGas"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="最大通气量预测"
            prop="MaxGasForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="呼吸机功能"
          show-overflow-tooltip
          align="center"
        >
          <el-table-column
            label="最大吸气压"
            prop="MaxAbsorbPressure"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="最大吸气压预测"
            prop="MaxAbsorbForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="最大呼气压"
            prop="MaxExhalePressure"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="最大呼气压预测"
            prop="MaxExhaleForecast"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        @size-change="pageSizeChange"
        @current-change="pageCurrentChange"
        :page-sizes="pageSizeList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>
  <script>
import dataFilter from "./components/dataFilter.vue";
import { exportData, getPageList } from "@/api/library/checkBreath.js";
export default {
  components: { dataFilter },
  data() {
    return {
      loading: false,
      total: 0,
      pageIndex: 1,
      pageSizeList: [10, 20, 30, 50, 80],
      pageSize: 10,
      datas: [],
      filter: {},
    };
  },
  methods: {
    handleExport() {
      this.loadInstance = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.filter = this.$refs.dataFilter.getfilter();
      exportData(this.filter)
        .then((res) => {
          this.loadInstance.close();
          if (res) {
            window.open(this.baseUrl + res);
          }
        })
        .catch((ex) => {
          this.msg.errorMsg("导出出错：" + ex);
          this.loadInstance.close();
        });
    },
    handleQuery() {
      let tempfilter = this.$refs.dataFilter.getfilter();
      this.filter = tempfilter;
      this.getData();
    },
    getData() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      this.loading = true;
      getPageList(this.filter)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.datas = res.Items;
            this.total = res.Total || res.Items.length;
          }
        })
        .catch((ex) => {
          this.loading = false;
          this.total = 0;
          this.datas = [];
        });
    },
    pageSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getData());
    },
    pageCurrentChange(val) {
      this.pageIndex = val;
      this.getData();
    },
  },
  mounted() {
    this.handleQuery();
  },
};
</script>
  <style lang="scss" scoped>
.index-container {
  .pagination {
    margin-top: 10px;
    text-align: right;
  }
  padding: 10px;
  .input {
    width: 150px;
  }
  .tabs-container {
    /deep/.el-tabs--border-card > .el-tabs__content {
      padding: 0;
      height: 1px;
    }
    .tab-content {
      margin-top: -2px;
      border: 1px solid #dcdfe6;
      border-top: 0;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    }
  }
}
</style>